module.exports = {
  apiBase: 'https://platform.onefortysix.agency/wp-json/wp/v2'
}
